<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    ref="dialog"
    :close-on-click-modal="false"
    class="dialog-dark password-luck-audience-list-dialog"
    :title="$t('passwordLuckDetail.抽奖观众')"
    width="640px"
    @open="onOpen"
    @close="onClose"
  >
    <!-- <AudienceScrollLoadList
      :visibleType="isVisible ? 'visible' : 'hide'"
      :raffleId="raffleId"
      :luckDetailSubmitCount="luckDetailSubmitCount"
      :itemHeight="25"
      :column="2"
    /> -->

    <AudiencePaginationList
      :visibleType="isVisible ? 'visible' : 'hide'"
      :raffleId="raffleId"
      :luckDetailSubmitCount="luckDetailSubmitCount"
      :column="2"
      :pageSize="20"
    />

    <div slot="footer" class="detail-footer">
      <el-button
        class="button-mini"
        size="mini"
        @click="cancelPasswordRaffle()"
      >
        {{$t('passwordLuckDetail.取消抽奖')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from "element-ui";
// import AudienceScrollLoadList from './audience-scroll-load-list.vue';
import AudiencePaginationList from './audience-pagination-list.vue';
import {cancelPasswordRaffle} from "@/api/liveRequest/luckDawApi";

export default {
  name: "PasswordLuckAudienceList",
  components: {
    [Dialog.name]: Dialog,
    // AudienceScrollLoadList,
    AudiencePaginationList
  },
  props: {
    raffleId: String,
    luckDetailSubmitCount: Number
  },
  beforeDestroy() {
    this.onClose();
  },
  data() {
    return {
      isVisible: false,
      hasConfirmPromise: false
    };
  },
  methods: {
    onOpen () {
      this.isVisible = true;
      this.hasConfirmPromise && this.$msgbox.close();
      this.hasConfirmPromise = false;
    },
    onClose () {
      this.isVisible = false;
      this.hasConfirmPromise && this.$msgbox.close();
      this.hasConfirmPromise = false;
    },
    cancelPasswordRaffle () {
      const raffleId = this.raffleId;
      console.log('cancelPasswordRaffle step1, raffleId:', raffleId);
      this.hasConfirmPromise = true;
      this.$confirm(this.$t('passwordLuckDetail.确认取消抽奖吗'), this.$t('passwordLuckDetail.提示'), {
        confirmButtonText: this.$t('passwordLuckDetail.确定'),
        cancelButtonText: this.$t('passwordLuckDetail.取消'),
      }).then(() => {
        this.hasConfirmPromise = false;
        console.log('cancelPasswordRaffle step2, raffleId:', raffleId, ' ,isVisible:', this.isVisible);
        if (!this.isVisible || !this.raffleId || raffleId !== this.raffleId) return;

        cancelPasswordRaffle({raffleId: raffleId})
        .then(() => {
            if (!this.isVisible || !this.raffleId || raffleId !== this.raffleId)
              return;

            this.$emit('setLuckDetailVisible', false);
          });
      }).catch(() => {
        this.hasConfirmPromise = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>

::v-deep .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 0px;
}

::v-deep .audience-pagination-list {
  margin-top: 20px;

  &.empty-data {
    margin-top: 0px;
  }

  .table .row .column {
    margin: 10px 4px;
  }
}

.detail-footer{
  text-align: center;
}
</style>
